


import React, { useState, useEffect } from "react";
import { Formik, Form, FieldArray } from "formik";
import { toast, ToastContainer } from "react-toastify";
import { Button, Container } from "reactstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  createQuize,
  getCategoryWithFilter,
  getQuizeWithIDS,
  updateQuize,
  generateRandom,
  getQuestionWithFilter
} from "../../slices/thunks";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import NameInput from "../../common/NameInput";
import DropdownInput from "../../common/DropdownInput";
import TextareaInput from "../../common/TextareaInput";

const Quizform = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [categoryQuestionCounts, setCategoryQuestionCounts] = useState({});
  const [categories, setCategories] = useState([]);
  const [initialValues, setInitialValues] = useState({
    name: "",
    description: "",
    time_limit: "",
    category_questions: [],
  });
console.log(categoryQuestionCounts);
  const generateQuizId = () => {
    const random = Math.random().toString(36).substring(2, 8); // 6 chars
    const timestamp = Date.now().toString(36);
    return `quiz_${timestamp}_${random}`;
  };

  const quizId = location.state?.id;

  // useEffect(() => {
  //   const fetchCategories = async () => {
  //     try {
  //       const res = await dispatch(getCategoryWithFilter());
  //       const categoryList = Array.isArray(res.payload?.data) ? res.payload.data : [];
  //       setCategories(categoryList);
  //     } catch (err) {
  //       console.error("Error fetching categories:", err);
  //       setCategories([]);
  //     }
  //   };
  //   fetchCategories();
  // }, [dispatch]);





    useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await dispatch(getCategoryWithFilter());
        const categoryList = Array.isArray(res.payload?.data) ? res.payload.data : [];
        
        // Filter categories where status is true
        const activeCategories = categoryList.filter(cat => cat.status === true);
        
        setCategories(activeCategories); // Set filtered categories
      } catch (err) {
        console.error("Error fetching categories:", err);
        setCategories([]); // Handle errors gracefully
      }
    };
  
    fetchCategories();
  }, [dispatch]);
  

  useEffect(() => {
    if (quizId) {
      const fetchQuizData = async () => {
        try {
          const res = await dispatch(getQuizeWithIDS(quizId));
          const quizData = res.payload?.data || {};
          // const categoryQuestions = JSON.parse(quizData.category_data || "[]");
          const categoryQuestions = typeof quizData.category_data === "string"
  ? JSON.parse(quizData.category_data)
  : quizData.category_data || [];

            console.log(categoryQuestions);
          setInitialValues({
            name: quizData.name || "",
            description: quizData.description || "",
            time_limit: quizData.time_limit || "",
            category_questions: categoryQuestions,
          });
        } catch (err) {
          console.error("Error fetching quiz data:", err);
        }
      };
      fetchQuizData();
    }
  }, [dispatch, quizId]);

  const handleSubmit = async (values, { resetForm }) => {
    const baseUrl = window.location.origin;
    const candidateFormLink = `${baseUrl}/candidate-form`;

    let quiz_id = quizId;

    // Generate new quiz_id only if it's a new quiz
    if (!quizId) {
      quiz_id = generateQuizId();
    }

    const payload = {
      quiz_id,
      name: values.name,
      description: values.description,
      time_limit: Number(values.time_limit),
      category_data: values.category_questions.map((q) => ({
        category_id: Number(q.category_id),
        num_questions: Number(q.num_questions),
        min_correct: Number(q.min_correct),
      })),
      quiz_link: candidateFormLink,
    };  
    

    try {
      if (quizId) {
        const res = await dispatch(updateQuize({ id: quizId, ...payload })).unwrap();
        if (res?.status === 200 || res?.success) {
          // toast.success("Quiz updated successfully!");
          navigate("/quiz");
        }

      } else {
        const res = await dispatch(createQuize(payload)).unwrap();
        if (res?.status === 200 || res?.success) {
          toast.success("Quiz created successfully!");
          // navigate("/quize");+
          navigate("/quiz");
        }


       
        // const genRes = await dispatch(generateRandom({ quiz_id }));
        // if (genRes.status === 200) {
        //   // toast.success("Questions generated successfully!");
        // 
        // }
      }

      resetForm();
      navigate("/quiz");
    } catch (error) {
      console.error("❌ Submission error:", error);
      toast.error(`Submission failed: ${error?.message || "Unknown error"}`);
    }
  };
  const [allQuestions, setAllQuestions] = useState([]);

  useEffect(() => {
    const fetchAllQuestions = async () => {
      try {
        const res = await dispatch(getQuestionWithFilter({}));
        const questions = Array.isArray(res.payload?.data) ? res.payload.data : [];
        setAllQuestions(questions);
      } catch (err) {
        console.error("Failed to fetch questions:", err);
      }
    };

    fetchAllQuestions();
  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={quizId ? "Edit Quiz" : "Add Quiz"} pageTitle="Quizzes" />
      </Container>
      <div className="page-content  justify-content-center align-items-center">
        <Container>
          <Formik enableReinitialize initialValues={initialValues} onSubmit={handleSubmit}>
            {(formik) => (
              <Form className="p-4 mt-3 mb-5 border rounded shadow-sm bg-white">
                

                <div className="row">
                  <div className="col-md-6 mb-3">
                   
                    <NameInput
                    label="Quiz Name"
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      required
                        placeholder="Enter the quiz name"
                        showHelp
                        helpText="Enter the Quiz name"
                    />
                  </div>

                 

                  <div className="col-md-6 mb-3">
                      <NameInput
                    label="Time Limit (in minutes)"
                      type="number"
                      id="time_limit"
                      name="time_limit"
                      className="form-control"
                      value={formik.values.time_limit}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      required
                      showHelp
                      helpText=" This defines how long candidates have to complete the quiz."
                         placeholder="Enter the time limit in minutes"
                    />
                  </div>
                </div>
                 <div className="col-md-12 mb-3">
                    <TextareaInput
                    label="Quiz Description"
                      id="description"
                      name="description"
                      className="form-control"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      required
                      showHelp
                      helpText=" Choose a unique and descriptive quiz name for easy identification."
                         placeholder="Provide a brief description of the quiz"
                    />
                  </div>

                <div className="mb-3">
                  
                  <FieldArray name="category_questions">
                    {(arrayHelpers) => (
                      <div>
                        {formik.values.category_questions.map((category, index) => (
                          <div key={index} className="mb-3">
                            <div className="row">
                              <div className="col-md-4">
                               


<DropdownInput

  label="Category"
  name={`category_questions[${index}].category_id`}
  options={categories.map((cat) => ({
    label: cat.name,
    value: cat.id,
  }))}
  defaultSelectedKey={category.category_id}
  onChange={(selectedOption) => {
    const event = {
      target: {
        name: `category_questions[${index}].category_id`,
        value: selectedOption?.value || "",
      },
    };
    formik.handleChange(event);

    const selectedCategoryId = selectedOption?.value;
    if (selectedCategoryId) {
      const questionCount = allQuestions.filter(
        (q) => q.category_id === Number(selectedCategoryId)
      ).length;

      setCategoryQuestionCounts((prev) => ({
        ...prev,
        [selectedCategoryId]: questionCount,
      }));
    }
  }}
  isClearable={false}
/>
                                {category.category_id && categoryQuestionCounts[category.category_id] !== undefined && (
                                  <small className="text-danger fw-bold text-dark">
                                    Available Questions: {categoryQuestionCounts[category.category_id]}
                                  </small>

                                )}

                              </div>

                              <div className="col-md-3">
                                {/* <label className="form-label">Number of Questions:</label> */}
                                <NameInput

                                label="Number of Questions"
                                  type="number"
                                  name={`category_questions[${index}].num_questions`}
                                  className="form-control"
                                  value={category.num_questions}
                                  onChange={formik.handleChange}
                                  required
                                  
                                />
                              </div>

                              <div className="col-md-3">
                                {/* <label className="form-label">Minimum Correct Answers:</label> */}
                                <NameInput
                                
                                label="Minimum Correct Answers"
                                  type="number"
                                  name={`category_questions[${index}].min_correct`}
                                  className="form-control"
                                  value={category.min_correct}
                                  onChange={formik.handleChange}
                                  required
                                />
                              </div>

                              <div className="col-md-2 d-flex justify-content-center align-items-center">
                                <Button
                                  type="button"
                                  color="light"
                                      className="fs-13 nav-link"
                                  onClick={() => arrayHelpers.remove(index)}
                             
                                >
                                  <i
  className="ri-delete-bin-7-fill fs-16 p-2 bg-soft-danger rounded-circle align-middle icon-red"
></i>   </Button>
                              </div>
                            </div>
                          </div>
                        ))}

                        <Button
                        type="button"
                            color="primary"
                          onClick={() =>
                            arrayHelpers.push({
                              category_id: "",
                              num_questions: 0,
                              min_correct: 0,
                            })
                          }
                        >
                          
                          Add Rules
                        </Button>
                      </div>
                    )}
                  </FieldArray>
                </div>

                <div className="text-end">
                  <Button color="primary" type="submit">
                    {quizId ? "Update Quiz" : "Create Quiz"}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Container>
      </div>
    </div>
  );
};

export default Quizform;


